export default "__VITE_ASSET__DR2djtRE__"